import type IAddLocationMessages from '.';

const addLocationMessages: IAddLocationMessages = {
	navigationWarning:
		'You have unsaved changes. Are you sure you want to leave?',
	successToastTitle: 'Success!',
	successToastBody: 'Created location',
	manageLocations: 'Manage Locations',
	masterOrderGuides: 'Master Order Guides',
	manageCustomers: 'Manage Customers',
	newLocation: 'New Location and Assign Charts',
	save: 'Save',
	nameValidationMessage: 'This field must be between 3 and 64 characters long.',
	namePlaceholder: 'Name',
	selectDistributionCenter: 'Select an OpCo',
	addressLine1ValidationMessage:
		'This field must be no longer than 64 characters long.',
	addressLine1Placeholder: 'Address Line 1',
	addressLine2ValidationMessage:
		'This field must be no longer than 64 characters long.',
	addressLine2Placeholder: 'Address Line 2',
	cityPlaceholder: 'City',
	cityValidationMessage: 'This field must be between 3 and 64 characters long.',
	stateValidationMessage: 'This field must be 2 characters long.',
	statePlaceholder: 'State',
	zipValidationMessage: 'This field must be a 5 or 5-4 digit zip code.',
	zipPlaceholder: 'Zip Code',
	shipToValidationMessage: 'This field must be 6 digits.',
	shipToPlaceholder: 'ShipTo',
	bidListValidationMessage:
		'This field must be at most 10 characters long, letters and numbers only.',
	bidListPlaceholder: 'Bidlist Name',
	restrictionValidationMessage:
		'This field must be at most 10 characters long, letters and numbers only.',
	restrictionPlaceholder: 'Restriction Chart Name',
	overrideValidationMessage:
		'This field must be at most 10 characters long, letters and numbers only.',
	overridePlaceholder: 'Override Chart Name',
	bidListDescriptionValidationMessage:
		'This field must be no longer than 30 characters long, letters, numbers and spaces only.',
	bidListDescriptionPlaceholder: 'Bidlist Description',
	restrictionDescriptionValidationMessage:
		'This field must be no longer than 30 characters long, letters, numbers and spaces only.',
	restrictionDescriptionPlaceholder: 'Restriction Chart Description',
	overrideDescriptionValidationMessage:
		'This field must be no longer than 30 characters long, letters, numbers and spaces only.',
	overrideDescriptionPlaceholder: 'Override Chart Description',
};

export default addLocationMessages;
